import { adgAdDefaultConfig } from './default';

// eslint-disable-next-line import/prefer-default-export
export const adgAdConfig = {
    sample: {
        gamingLarge: {
            ...adgAdDefaultConfig,
            id: '1685498328026-0',
            displayid: '1',
            adType: 'LARGE',
            defineSlot: {
                link: '/49720294/auportal_sp_easygame_diceconnectingrs_320x100',
                size: '[320, 100]'
            }
        },
        gamingSmall: {
            ...adgAdDefaultConfig,
            id: '1676958661145-0',
            displayid: '1',
            adType: 'SP',
            defineSlot: {
                link: '/49720294/auportal_sp_easygame_diceconnectingrs_300x250',
                size: '[[300, 250], [336, 280]]'
            }
        },
        result: {
            ...adgAdDefaultConfig,
            id: '1676958745657-0', //88804
            displayid: '2',
            adType: 'RECT',
            defineSlot: {
                link: '/49720294/auportal_sp_easygame_diceconnectingrs_300x250', //string define
                size: '[[300, 250], [336, 280]]'
            }
        },
        ready: {
            ...adgAdDefaultConfig,
            id: '1676958661145-0',
            displayid: '2',
            adType: 'INFEED',
            defineSlot: {
                link: '/49720294/auportal_sp_easygame_diceconnectingrs_300x250',
                size: '[[300, 250], [336, 280]]'
            }
        },
        retry: {
            ...adgAdDefaultConfig,
            id: '1685498450563-0',
            displayid: '2',
            adType: 'INFEED',
            defineSlot: {
                link: '/49720294/auportal_sp_easygame_diceconnectingrs_interstitial',
                size: '[[336, 280], [300, 250], [320, 480]]',
            }

        },
        reward: {
            ...adgAdDefaultConfig,
            id: '1685498450563-0',
            displayid: '2',
            adType: 'INFEED',
            defineSlot: {
                link: '/49720294/auportal_sp_easygame_diceconnectingrs_interstitial',
                size: '[[336, 280], [300, 250], [320, 480]]',
            }
        },
    },
};